import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Select, { StylesConfig } from 'react-select';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { getAccountInvoiceTemplateAsync, resetSelectedRecordObjectInState, updatePagination } from "./invoiceTemplateSlice";
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray, sortData } from '../../../common/timeLiveFunction';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import { getFilteredList, getValueFromResource } from "../../../common/timeLiveFunction";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import InvoiceTemplateOffCanvas from '../../../common/OffCanvas';
import { InvoiceTemplateForm } from "./invoiceTemplateForm";
import { InvoiceTemplateItem } from "./invoiceTemplateItem";
import PageSizeSelect from "../../../common/PageSizeSelect";
import fetchAPI from "../../../common/fetchAPI";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}
    export const InvoiceTemplate = () => {
        const dispatch = useAppDispatch();
        const modelRef = useRef<any>(null);
        const { t } = useTranslation();
        const { invoicetemplateList, isReload, selectedRecord, isLoading, search, pageNo, pageSize, sortOrder, sortColumn } = useAppSelector((state) => state.invoiceTemplate)
        const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
        // const [pageSize, setPageSize] = useState(10);
        // const [currentPage, setCurrentPage] = useState(1);
        // const [searchTerm, setSearchTerm] = useState('');
        const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
        const [loader, setLoader]=useState(false);
        const location = useLocation();
        const navigate = useNavigate();    
    
        // useLayoutEffect(() => {
        //     const fetchPagePermissions = async () => {
        //         if (pageId && pageId !== '') {
        //             const res = await dispatch(getPagePermissionsAsync(pageId));
        //             if (!res.payload.IsList) {
        //                 navigate('../error/403');
        //             }
        //         } else if (!pageId && menuList && menuList.length > 0) {
        //             const routeName = location.pathname.split('/').filter(Boolean)[0];
        //             const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
        //             if (foundItem) {
        //                 const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
        //                 if (!res.payload.IsList) {
        //                     navigate('../error/403');
        //                 }
        //             } else {
        //                 navigate('../error/403');
        //             }
        //         }
        //     };
    
        //     fetchPagePermissions();
        // }, [dispatch, menuList, pageId]);

        const getPagePermissions = async()=>{
            try {
                setLoader(true);
                const response = await fetchAPI(`api/v2/PagePermission/PagePermissions/${pageId}`,'GET', '', true)
                const result = await response.json();
                if(!result?.IsList){
                    navigate('../error/403')
                }
            } catch (error) {
                console.log(error);
            }finally{
                setLoader(false);
            }
        }
     useEffect(()=>{
        getPagePermissions()
     },[])
        const openModal = () => {
            setIsModalOpen(true);
        };
    
        const closeModal = () => {
            setIsModalOpen(false);
        };
    
        // const handlePageChange = (pageNumber: any) => {
        //     setCurrentPage(pageNumber);
        // };
        // const handleSearch = (event: any) => {
        //     const { value } = event.target;
        //     setSearchTerm(value);
        //     setCurrentPage(1);
        // };
    
        // const handlePageSizeChange = (selectedOption: any) => {
        //     const { value, label } = selectedOption;
        //     setPageSize(Number(value));
        //     setCurrentPage(1);
        // };
    
        // const filteredData: any = getFilteredList(invoicetemplateList, searchTerm);    
        // const indexOfLastItem = currentPage * pageSize;
        // const indexOfFirstItem = indexOfLastItem - pageSize;
        // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
        // const totalItems = invoicetemplateList.length;
        // const recordsFiltered = filteredData.length;    
    
          const filteredData: any = getFilteredList(invoicetemplateList, search);
            const indexOfLastItem = pageNo * pageSize;
            const indexOfFirstItem = indexOfLastItem - pageSize;
            // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
            const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
            const totalItems = invoicetemplateList.length;
            const recordsFiltered = filteredData.length;
         
           const handlePageChange = (pageNumber: any) => {
                // setCurrentPage(pageNumber);
                let objects = {
                    "pageSize": pageSize,
                    "pageNo": pageNumber,
                    "search": search
                }
        
                dispatch(updatePagination(objects));
            };
        
            const handleSearch = (event: any) => {
                const { value } = event.target;
                // setSearchTerm(value);
                // setCurrentPage(1);
                let objects = {
                    "pageSize": pageSize,
                    "pageNo": 1,
                    "search": value
                }
                dispatch(updatePagination(objects));
            };
        
            const handlePageSizeChange = (selectedOption: any) => {
                const { value, label } = selectedOption;
                // setPageSize(Number(value));
                // setCurrentPage(1);
                let objects = {
                    "pageSize": value,
                    "pageNo": 1,
                    "search": search
                }
                dispatch(updatePagination(objects));
            };
        useEffect(() => {
            if (isReload) {
                dispatch(getAccountInvoiceTemplateAsync());
            }
    
        }, [isReload])
    
        useEffect(() => {
            dispatch(getAccountInvoiceTemplateAsync());
        }, [dispatch])
    
        const handleOnClickEvent = () => {
            dispatch(resetSelectedRecordObjectInState());
            setIsModalOpen(true);   
        }

        const onDeleteSelectedClick = () => {

        }
        const generalObject = {
            "name": (Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update ', dispatch, t) : getValueFromResource('Add ', dispatch,t)) + ' ' +  getValueFromResource( 'Invoice Template', dispatch,t),
            "width": "700px",
            "componentName": < InvoiceTemplateForm t={t} />
        }

        return (
            <>
    
        {(isLoading || loader) && <Loader />}   
      
                <div className="card card-custom admin-card">
                    <div className="card-header card-drop sticky-top bg-white fixed-top">
                        <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">
                            {getValueFromResource('Invoice Template', dispatch, t)}
                            <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-description"
                                data-tooltip-content={getValueFromResource('Create and manage invoice templates that define the layout and formatting of invoices. These templates can be selected when generating new invoices.', dispatch, t)}
                            >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                            </div>
                        </h3>
                        <div className="card-toolbar align-items-center">
                            <div className="position-relative">
                                <input
                                    type="text"
                                    value={search}
                                    onChange={handleSearch}
                                    placeholder={getValueFromResource('Search', dispatch, t)}
                                    className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                    data-kt-user-table-filter="search"
                                />
                                <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>
                            <div className='h-35px w-1px mx-1'></div>
                            <div className="d-flex align-items-center">
                                {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>

                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div>
                                {(currentItems.length > 0) ? (
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    >
                                    </CustomPagination>
                                ) : null}
                            </div>
                            {(IsAdd || (IsDelete && invoicetemplateList.some((item: any) => item.isSelected === 1))) ? (
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            ) : null
                            }
    
                            {IsAdd &&
                                <button id="kt_OffCanvas" type="button"
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                    onClick={handleOnClickEvent}
                                    style={{ marginRight: '2px', display: invoicetemplateList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                >
                                    {getValueFromResource('Add Invoice Template', dispatch,t)}
                                </button>
                            }
                            {IsDelete &&
                                <>
                                    <div className="text-muted me-5" style={{ marginRight: '2px', display: invoicetemplateList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                        <span className="me-2" data-kt-user-table-select="selected_count">{invoicetemplateList.filter((item: any) => item.isSelected === 1).length}</span> 
                                        {/* {t('Selected')} */}
                                        {getValueFromResource('Selected', dispatch,t)}
                                    </div>
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                        style={{ marginRight: '2px', display: invoicetemplateList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                    >
                                        <i className="bi bi-trash fs-5 me-2"></i>
                                        {/* {t('Delete')} */}
                                        {getValueFromResource('Delete', dispatch,t)}
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                    {IsList &&
                        // <div className="card-body">
                        <div className="card-Report-body">
                            <div className="table-responsive">
                                <InvoiceTemplateItem invoicetemplateList={currentItems} onopenModal={openModal} oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                            </div>
                        </div>
    
    
                    }
                </div>
               
                <InvoiceTemplateOffCanvas obj={generalObject} />
                <ReactTooltip
                    id="tooltip-description"
                    style={TOOLTIP_STYLE}
                    place="bottom"
                    delayShow={100}
                    delayHide={100}
                    clickable
                    render={({ content }) => {
                        const isLongContent = content && content?.length > 90;
                        return (
                            <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                                {content}
                            </div>
                        );
                    }}
                />
            </>
        )
    
    }